import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "./Layout.css";

const Layout = () => {
  return (
    <div className="layout-container">
      <Navbar />
      <div className="main-container">
        <Sidebar />
        <main className="content-area">
          <div className="container-fluid py-4">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
